import React, { useState, useEffect } from "react";
import {
	message
} from "antd";
import { useParams } from 'react-router-dom';
import moment from "moment";

import DataTable from "../../Components/Common/DataTable";
import { getPagingAttendance } from "../../helpers/helper";

const Attendance = () => {
	document.title = "Chi tiết ca điểm danh";
	const [listAttendance, setListAttendance] = useState([]);
	const { id } = useParams();
	//pagination
	const [totalPage, setTotalPage] = useState(1);
	const [indexPage, setPageIndex] = useState(1);
	const [loading, setLoading] = useState(true);
	const [pageSize, setPageSize] = useState(10);

	const getAllData = async (_prams) => {
		try {
			const params = _prams
				? _prams
				: {
					pageIndex: indexPage,
					pageSize: pageSize,
					shift: id
				};
			const dataRes = await getPagingAttendance(params);

			if (!dataRes) {
				message.error(`Bạn không có quyền xem danh sách người điểm danh!`);
				return false;
			}
			setTotalPage(dataRes.totalPages);
			const data =
				dataRes?.data &&
				dataRes?.data.length > 0 &&
				dataRes?.data.map((item) => {
					return {
						key: item._id,
						shiftName: item.shift ? item.shift.shiftName : '',
						createdTime: moment(new Date(item.createdTime)).format("DD/MM/YYYY HH:mm:ss"),
						updatedTime: item.updatedTime ? moment(new Date(item.updatedTime)).format("DD/MM/YYYY HH:mm:ss") : '',
						createdByName: item.createdBy ? item.createdBy.username : '',
						updatedByName: item.updatedBy ? item.updatedBy.username : ''
					};
				});
			return dataRes?.data ? data : [];
		} catch (error) {
			message.error('Bạn không có quyền xem chi tiết những người điểm danh!');
			setTotalPage(0)
			return [];
		}
	};
	useEffect(() => {
		setLoading(true);
		async function fetchData() {
			const dataRes = await getAllData(null, indexPage);
			setListAttendance(dataRes);
			setLoading(false);
		}
		fetchData();
	}, []);


	const columns = [
		{
			title: "Tên ca điểm danh",
			dataIndex: "shiftName",
		},
		{
			title: "Người điểm danh",
			dataIndex: "createdByName",
		},
		{
			title: "Thời gian điểm danh",
			dataIndex: "createdTime",
		}

	];
	const onPageChange = (page, page_size) => {
		setPageIndex(page);
		setPageSize(page_size);
		onPageChangeAtSearch(page, page_size);
	}

	const onPageChangeAtSearch = async (indexPage, page_size) => {
		setLoading(true);
		const params = {
			pageIndex: indexPage,
			pageSize: page_size,
			shift: id
		};
		const dataRes = await getAllData(params, indexPage);
		setListAttendance(dataRes.length > 0 ? dataRes : false);
		setLoading(false)
	}

	return (
		<>
			<div className="page-content">

				<DataTable
					listData={listAttendance}
					pageSize={pageSize}
					columns={columns}
					indexPage={indexPage}
					totalPage={totalPage}
					onPageChange={onPageChange}
					loading={loading}
				/>

			</div>
		</>
	);
};
export default Attendance;